import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ChartSeries from 'app/react/chart/ChartSeries.jsx';
import LineChart  from 'app/react/chart/LineChart.jsx';
//import ReportTable from 'app/react/ReportTable.jsx';
global.jQuery = require('jquery');
// 
 require('bootstrap/dist/css/bootstrap.min.css');
 require('bootstrap/dist/js/bootstrap.min.js');

// bielany - strona do zagniezdzenia
// http://www.bielany.waw.pl/page/210,monitoring-powietrza.html
// import react and some other libs
import {
  Moment, DOMTools
} from 'app/react/Boot.jsx';

import Teaser from 'app/react/bielany/Teaser.jsx';

require('react-d3');

import SimpleTable from 'app/react/table/SimpleTable.jsx';;
var DatePicker = require("react-bootstrap-date-picker");
//var DatePicker = require("react-datepicker");

import {
  mapParTypeName, mapParTypeNameToTag, mapUnitNameToTag, mapUnitName, tickFormatter, LegendComponent, ColorTable
} from 'app/react/core/CoreUtils.jsx';

class KasCon extends Component {

  constructor(props) {
    super(props);

    //this.headerRenderer = new HeaderRenderer();
    //this.cellRenderer = new CellRenderer();
    this.state = {
      lines: [],
      rows: [],
      charts: [],
      data: "",
      json: {},
      teaserValues: [],
      activeTab: null,
      activeView: '',
      containerSize: 800,
      calendarDate: new Date(),
      calendarISODate: new Date().toISOString()
    };

    this.displayMode = this.configureDisplayModes();

    var codes = [
    ];

    this.viewConfig ={

      headersDescription: {
        headers: [
          {code: 'Data', colspan: 1 },
          {code: 'Ludowa', colspan: 3},
          {code: 'Kraszewskiego', colspan: 3}
        ],
      },

      enabledViews: ["1h", "24h"],
      enabledTabs: ["default", "comparison"],

      tabs: {
        "default": {
          name: "Lokalizacje pomiarowe",
          short: "Lokalizacje",
          codes: [
            {title: "Krynica - Ludowa", codes: ["051PM10A", "051PM25A", "051PM1A" ]},
            {title: "Krynica - Kraszewskiego", codes: ["052PM10A", "052PM25A", "052PM1A"]},
          ],
        },
        "comparison": {
          name: "Frakcje pyłu",
          short: "Frakcje",
          codes: [
            {title: "PM10 Krynica - Ludowa/Kraszewskiego", codes: ["051PM10A", "052PM10A"]},
            {title: "PM25 Krynica - Kraszewskiego/Ludowa", codes: ["051PM25A", "052PM25A"]},
            {title: "PM1 Krynica - Kraszewskiego/Ludowa", codes: ["051PM1A", "052PM1A"]},
          ],
        },
        "default_24h": {
          name: "Lokalizacje pomiarowe",
          short: 'Lokalizacje',
          codes: [
            {title: "Krynica - Ludowa", codes: ["051PM10A", "051PM25A", "051PM1A" ]},
            {title: "Krynica - Kraszewskiego", codes: ["052PM10A", "052PM25A", "052PM1A"]},
          ],
        },
        "comparison_24h": {
          name: "Frakcje pyłu",
          short: 'Frakcje',
          codes: [
            {title: "PM10 Krynica - Ludowa/Kraszewskiego", codes: ["051PM10A", "052PM10A"]},
            {title: "PM25 Krynica - Kraszewskiego/Ludowa", codes: ["051PM25A", "052PM25A"]},
            {title: "PM1 Krynica - Kraszewskiego/Ludowa", codes: ["051PM1A", "052PM1A"]},
          ],
        }
      },

      // list of all measurements
      // this is used for getting data
      codes: codes,

      views: [
        //        "teaser",
        //        "normal",
        "charts",
        //        "table"
      ],

      blocks: {

        // teaser config
        teaser : {
          codes: codes,
        },

        // list of charts
        charts : {

          // list of measurement codes
          codes: codes,

        },

        // table of everything
        tablething : {
          codes: ["051PM10A", "051PM1A", "051PM25A", "052PM10A", "052PM1A", "052PM25A"],
        }
      }
    };

    for (var name in this.viewConfig.tabs) {
      this.viewConfig.tabs[name]._id = name;
    }

    this.state.activeTab = this.viewConfig.tabs.default;
  }

  reportSizeChange(size) {
    //this.setState({containerSize: size})
  }

  processResponse(json, _entryStep) {
    var startTimestamp = json.start;
    var endTimestamp = json.end;
    var tp = "ts";
    var ts = 0;
    var entryStep = _entryStep || 3600;
    var timeshift = 0;
    var j = 0;
    var valuesLength = json.values.length;

    //console.log('dupa: ', endDate.getTime())
    //    endTimestamp = Math.floor(((endDate.getTime() - 23 * 60 * 1000) / 1000));
    //
    if (entryStep == 86400) {
      // we can modify endTimestamp to match whole day
      var endDate = new Date(endTimestamp * 1000);
      //var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1)
      endDate.setHours(0);
      endDate.setMinutes(0);
      endDate.setSeconds(0);

      endTimestamp = Math.floor(endDate.getTime() / 1000);

      var startDate = new Date(startTimestamp * 1000);
      startDate.setHours(24);
      startDate.setMinutes(0);
      startDate.setSeconds(0);

      startTimestamp = Math.floor(startDate.getTime() / 1000);


    } else {
      startTimestamp = Math.ceil((startTimestamp) / entryStep) * entryStep;
      endTimestamp = Math.floor((endTimestamp) / entryStep) * entryStep;
    }

    console.log('startTimestamp: ', startTimestamp, 'endTimestamp: ', endTimestamp, json.end, json.values.length )

    //  debugger;
    for (var j = 0; j < valuesLength; j++) {
      var data = json.values[j];

      // iterate over data and insert dummies
      var newArray = [];
      var len = data.length;
      var lastTs = startTimestamp;
      var k = 0;

      for (var i = 0; i < len; i++) {
        ts = data[i].t;

        if (i == 0 && ts > startTimestamp) {
          //debugger;
          for (k = startTimestamp; k < ts; k += entryStep) {
            newArray.push({
              t: k, v: '', s: 'N', a: 'gap'
            });
          }

        } else if (ts - lastTs > entryStep) {
          //debugger;

          for (k = lastTs + entryStep; k < ts; k += entryStep) {
            newArray.push({
              t: k, v: '', s: 'N', a: 'gap'
            });
          }
        }

        newArray.push(data[i]);
        lastTs = ts;
      }

      if (len == 0) {
        lastTs -= entryStep;
      }

      if (lastTs < endTimestamp) {
        //debugger;

        // update it
        // this.endTimestamp = lastTs;
        for (var k = lastTs + entryStep; k <= endTimestamp; k += entryStep) {
          newArray.push({
            t: k, v: '', s: 'N', a: 'gap'
          });
        }
      }

      data = null;
      data = newArray;

      json.values[j] = data;
    }

    //console.log('przetworzeone: ', json.values);
    var values = [];

    // now will convert into to normal table
    json.values = json.values[0].map((r, i) => {
      var sample = {t: r.t};
      json.vars.forEach((p, j) => {
        var code = p.split(':')[0];
        var s = json.values[j][i];

        //    console.log('what is s: ', j, i, json.values.length, json.values[j].length, s)
        // we can test here for status
        sample[code] = s.v;
      })
      return sample;
    })

    console.log('result json: ', json)

    return json;
  }

  componentDidMount() {
    var dp = this.props.dataProvider;

    // window.setTimeout(() => {
    //   jQuery(ReactDOM.findDOMNode(this.refs.toggleButton)).trigger('click');
    // }, 1000)
    this.initData(new Date());
  }

  createSerie(configObject) {
    var {fieldName, id} = configObject;

    // applying some default values
    configObject.scale = Object.assign(
      { type: 'dynamic', visible: false, tickSize: 5}, configObject.scale
    );

    configObject.timeline = Object.assign(
      {
        type: 'dynamic',
        nice: true,
        format: '%H:%M',

        formatter: tickFormatter,
        ticksCount:  10,

        //range: staticRange
      },
      configObject.timeline
    )

    configObject.style = Object.assign(
      { stroke: ColorTable[id], "stroke-width": 1.5 }, configObject.style
    );


    // console.log('creating serie: ', i, site)
    return ChartSeries.createLineSerie(
      // default values for serieConfig
      Object.assign({
        // series data
        data: null,
        // accessor functions
        timeAccessor: (d) => { return d.t * 1000},
        // value accessor
        valueAccessor: (d) => { return Math.round(parseFloat(d[fieldName])) },
        // serie name
        id: null,

        // fieldName
        fieldName: null, name: null,
        // legend names
        legendName: null,
        shortLegendName: null,

        // drawing type
        drawType: "line"
      },

      // user specified configuration
      configObject)
    )
  }


  getStationForChart(code) {
    return /051.*/.test(code) ? "Ludowa" : "Kraszewskiego";
  }

  buildChart(tabName, title, codes, json) {
    var drawType;
    var max = 0, min = 0;
    var series;
    var dp = this.props.dataProvider;
    var format = /.*_24h/.test(tabName) ? "%d %b" : '%a %H:00';

    console.log('build tabName: ', tabName)

    for (var z = 0; z < json.values.length; z++) {
      var sample = json.values[z];

      codes.forEach((c, i) => {
        if (sample[c] > max) {
          max = sample[c];
        }
        if (sample[c] < min) {
          min = sample[c];
        }
      })
    }

    var types = {
      "pm10" : {color: "#ddd", drawType: "area", decimals: 0, sharedExtentBase: 0, sharedExtentCeil: 100},
      "pm2.5" : {color: "#aaa",drawType: "area", decimals: 0, sharedExtentBase: 0, sharedExtentCeil: 100},
      "pm1" : {color: "black", drawType:"line", decimals: 0, sharedExtentBase: 0, sharedExtentCeil: 100},
      "temp" : {color: "rgba(255, 10, 10, 0.7)", drawType:"line", decimals: 1, sharedExtentBase: 0, sharedExtentCeil: 50},
      "humid" : {color: "rgba(68, 160, 232, 0.7)", drawType:"line", decimals: 1, sharedExtentBase: 60, sharedExtentCeil: 100},
      "press" : {color: "rgba(255, 213, 0, 0.7)", drawType:"area", decimals: 0, sharedExtentBase: 990, sharedExtentCeil: 1020},
      "ws" : {color: "red", type:"line", decimals: 1, sharedExtentBase: 0, sharedExtentCeil: 24},
      "rain" : {color: "green", drawType:"area", decimals: 1, sharedExtentBase: 0, sharedExtentCeil: 40}
    }

    series = codes.map((c, i) => {
      var meas = dp.getStore('measurement_by_code').getRecordById(c);
      var type = meas.compound_type;

      var station = this.getStationForChart(c);

      console.log('my meas is: ', c, type, station)

      //var serie = this.createSerie(i, c, null, json.values, {}, drawType, i == 0, station + "." + mapParTypeName(meas.compound_type.toUpperCase()), 5, null, format);
      var serie = this.createSerie({
        id: i,
        style: {
          //stroke: color ? (typeof color == "number" ? ColorTable[color % (ColorTable.length - 1)] : color) : ColorTable[i + 5]
          //  stroke: (type == "pm10" ? "rgba(68, 160, 232, 0.7)" : (type == "pm2.5" ? "rgba(255, 213, 0, 0.7)": "rgba(255, 100, 0, 0.7)")), // ,#44A0E8, #FFD500
          //stroke: types[type].color
          stroke: ColorTable[i]
        },
        name: c,
      //  drawType: types[type].drawType,
        fieldName: c,
        data: json.values,
        //legendName: getLegendNameForMeas(meas),
        //shortLegendName: getLegendNameForMeas(meas),
       legendName:
        ["default", "default_24h"].includes(tabName) ? mapParTypeName(meas.compound_type.toUpperCase()) :
        ["meteo", "meteo_24h", "comparison", "comparison_24h"].includes(tabName) ? station :
        station + "." + mapParTypeName(meas.compound_type.toUpperCase()),
        shortLegendName: ["meteo", "meteo_24h"].includes(tabName)?  station.substr(0,3) + "." : mapParTypeName(meas.compound_type.toUpperCase()),
        timeline: {
          ticksCount: 5,
          format: format,
          nice: false
        },
        sharedExtentBase: types[type].sharedExtentBase,
        sharedExtentCeil: types[type].sharedExtentCeil,
        scale: {
          type: 'dynamic',
          visible: i < 1,
          //range: [0, 100]
        },
        // id: i,
        // style: {
        //   stroke: ColorTable[i]
        // },
        //
        // name: c,
        // fieldName: c,
        // data: json.values,
        // legendName: station + "." + mapParTypeName(meas.compound_type.toUpperCase()),
        // shortLegendName: mapParTypeName(meas.compound_type.toUpperCase()),
        //
        // timeline: {
        //   ticksCount: 5,
        //   format: format,
        //   nice: false
        // },
        // scale: {
        //   type: 'static',
        //   range: [0, max*1.1 > 60 ? Math.round(max * 1.1) : 60],
        //   visible: i == 0
        // }
      })

      return serie;
    })

    series.title = title;
    series.levels = [];
    console.log('my tabName: ', tabName, series.levels)

    if (tabName != "meteo") {
      // mozna tutaj takze zmodyfikowac skale ale damy sobie na razie spokoj
      //if (max > 50) {
        series.levels.push(
          {value: 50, style: {color: 'green'}}
        );
//      }

  //    if (max > 200) {
        series.levels.push(
          {value: 200, style: {color: 'red'}}
        );
  //    }
  //    if (max > 300) {
        series.levels.push(
          {value: 300, style: {color: 'brown'}}
        );
    //  }
    }

    series.guideLine = {
      style: {color: '#eeeeee'}
    }


    return series;
  }

  getFetchParams(type) {
    var vars = [], start = 0, end = 0;
    var now = new Date(this.state.calendarDate);

    vars = this.viewConfig.blocks.tablething.codes.map((r) => {
      return r + ":A" + type;
    });

    if (this.viewConfig.blocks.tablething.meteo) {

      this.viewConfig.blocks.tablething.meteo.codes.forEach((r) => {
        vars.push(r + ":A" + type);
      });
    }

    switch (type) {
      case "1h":
        end = Math.floor(now.getTime() / 1000);

        now.setDate(now.getDate() - 3);
        now.setHours(now.getHours() - 1);
        console.log("my date is now 1h: ", now)

        start = Math.floor(now.getTime() / 1000);
        break;
      case "24h":
        now.setHours(1);
        now.setDate(now.getDate() - 1);

        end = Math.floor(now.getTime() / 1000);

        now.setMonth(now.getMonth() - 1);
        console.log("my date is now 24h: ", now)

        start = Math.floor(now.getTime() / 1000)
        break;
    }

    return {
      type: 'chart',
      start: start,
      end: end,
      vars: vars.join(',')
    }
  }

  initData(calendarDate) {
    var dp = this.props.dataProvider;
    this.lastFetch = new Date();

    this.state.calendarDate = calendarDate;
    this.state.calendarISODate = calendarDate.toISOString();

    console.log('setting new calendar date: ', this.state.calendarDate)

    // to be able to use dynamic interface we need to specify url argumetns
    // vars, start, end ... (or depend on server configuration (this could be much better))

    Promise.all([
      dp.fetchData(this.getFetchParams('1h')),
      dp.fetch24hData(this.getFetchParams('24h'))
    ])
    .then((results) => {
      var [json, json24h] = results;

      console.log('my results: ', results)

      //debugger;
      json = this.processResponse(json);
      json24h = this.processResponse(json24h, 86400)

      this.state.values = json.values;
      this.state.json = json;

      this.state.values24h = json24h.values;
      this.state.json24h = json24h;

      var now = Math.floor(new Date().getTime() / 1000);
      this.state.reversedValues = this.state.values.filter((row, i) => {
        return row.t <= now;
      }).slice().reverse();

      this.state.reversedValues24h = this.state.values24h.filter((row, i) => {
        return row.t <= now;
      }).slice().reverse();

      this.viewConfig.enabledTabs.forEach((tabName) => {
        var a = this.viewConfig.tabs[tabName];
        var charts = [];

        a.codes.forEach((r, i) => {
          charts.push(this.buildChart(tabName, r.title, r.codes, this.state.json))
        })

        a.charts = charts;
        console.log('building chart: ', tabName, charts)
      });

      this.viewConfig.enabledTabs.forEach((name) => {
        var tabName = name + "_24h";
        var a = this.viewConfig.tabs[tabName];
        var charts = [];
        a.codes.forEach((r, i) => {
          charts.push(this.buildChart(tabName, r.title, r.codes, this.state.json24h))
        })
        a.charts = charts;
      });

      console.log('forcing new calendar date: ', calendarDate, this.state.calendarDate)

      //console.log("reversed: ", this.state.reversedValues)
      this.forceUpdate();
    })
  }

  determineDisplayMode() {
    var target = document.getElementById('react-content');
    var parent = target.parentNode;
    var mode = "";
    var dimensions = null;

    if (parent.nodeName == "BODY") {
      mode = "BODY";
    }

    if (parent.nodeName == "DIV") {
      mode = "DIV";

      // we want to get
      dimensions = DOMTools.getElementDimensions(parent);

      while (dimensions.width == 0) {
        parent = parent.parentNode;
        dimensions = DOMTools.getElementDimensions(parent);
      }

      dimensions.width = dimensions.width - 20;
    }

    return {mode: mode, dimensions: dimensions};
  }

  configureDisplayModes() {

    var mode = this.determineDisplayMode();

    console.log('my mode: ', mode)
    var w = mode.dimensions && mode.dimensions.width || 950;

    var maxWidth = 950;
    var minWidth = 800;
    var chartWidth = 900;
    var chartHeight = chartWidth * 0.3;
    var tableWidth = 900;
    var tableHeight = 400;

    var limitWidth = 800;

    if (mode.mode == "DIV") {
      maxWidth = w;
      minWidth = w;
      chartWidth = w > limitWidth ? w - 250: w;
      chartHeight = chartWidth * 0.3;
      tableWidth = w > limitWidth ? 250 : "";
      tableHeight = w > limitWidth ?  3 * (chartHeight) + (3 - 1) * 20 : 400;
    }


    // for test only
    maxWidth = "";
    minWidth = 300;
    chartWidth = "100%";
    chartHeight = 260;
    tableWidth = "100%";
    tableHeight = 400;

    var config = {
      mode: mode.mode,
      maxWidth: maxWidth, minWidth: minWidth,
      chartWidth: chartWidth, chartHeight: chartHeight,
      tableWidth: tableWidth, tableHeight: tableHeight
    };

    return config;
  }

  onRefreshClicked(event) {
    event.preventDefault();
    this.initData(new Date());
  }

  generateTable (desc, codes, reactiveDescription, tableWidth, tableHeight) {

    console.log('generating table: ', desc)
    return <SimpleTable
      dateFormat={(/.*_24h/.test(this.state.activeTab._id) ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:00')}
      dataProvider={this.props.dataProvider} tableWidth={tableWidth} tableHeight={tableHeight} desc={desc}
      reactiveDescription={reactiveDescription}
      codes={codes}
      values={(/.*_24h/.test(this.state.activeTab._id) ? this.state.reversedValues24h : this.state.reversedValues)}
    />
  }

  render() {
    var dp = this.props.dataProvider;
    var blocks = this.viewConfig.blocks;
    var now = new Date();

    // <div style={{width: 950, float: 'left', textAlign: 'center', fontSize: '20px'}}>
    //    Stężenie pyłu zawieszonego PM10 - Wadowice {now.toLocaleDateString('pl')}
    //  </div>
    var dm = this.displayMode;

    console.log('rendering with calendar date: ', this.state.calendarDate)

    var maxWidth = dm.maxWidth;
    var minWidth = dm.minWidth;
    var chartWidth = dm.chartWidth;
    var chartHeight = dm.chartHeight;
    var tableWidth = dm.tableWidth;
    var tableHeight = dm.tableHeight;
    var mode = dm.mode;

    //console.log('my view config tabs: ', this.state.activeTab.codes)
    //console.log('display mode: ', chartWidth)
    var charts = this.state.activeTab.charts;

    var reactiveDescription = {
      width: {
        760: {
          timeline: {
            ticksCount: 8
          },
          scale: {
            tickSize: 5
          },
          legendSize: 'full',
          containerHeight: 1
        },
        500: {
          timeline: {
            ticksCount: 5
          },
          scale: {
            tickSize: 3
          },
          legendSize: 'compact',
          containerHeight: 0.8
        },
        200: {
          timeline: {
            ticksCount: 3
          },
          scale: {
            tickSize: 3
          },
          legendSize: 'compact',
          containerHeight: 0.5
        },
        0: {
          timeline: {
            ticksCount: 2
          },
          scale: {
            tickSize: 2
          },
          legendSize: 'compact',
          containerHeight: 0.3
        }
      }
    };

    var containerSize = this.state.containerSize;

  //  console.log('my state active tab: ', this.state.activeTab._id.split("_"))
    var baseName = this.state.activeTab._id.split('_')[0];

    //console.log('tableWidth: ', tableWidth)
    return (
      <div style={{width: tableWidth, minWidth: 200, maxWidth: 1000}}>
        <nav className="navbar navbar-default navbar-fixed-top" style={{maxWidth: 1000}}>
          <div className="container-fluid">
            <div className="navbar-header">
              <button ref="toggleButton" type="button" className="navbar-toggle collapsed pull-left" data-toggle="collapse" style={{marginLeft: 20}} data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </button>

            <div className="navbar-custom-title">
              {this.state.activeTab.name} <br/> {(this.state.activeView == ""? "Pomiary 1h" : "Pomiary " + this.state.activeView)}
            </div>
            </div>
            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1" style={{width: tableWidth}}>
              <ul className="nav navbar-nav" style={{width: '100%'}}>
                {
                  this.viewConfig.enabledTabs.map((tabName, i) => {
                    var r = this.viewConfig.tabs[tabName + (this.state.activeView == ""? "" : "_" + this.state.activeView)];
                    var reg = new RegExp(tabName + ".*");
                    var selected = reg.test(this.state.activeTab._id);

                    return <li key={i} className={selected ? "active" : ""}
                      onClick={(event) => {event.preventDefault(); (r.name != this.state.activeTab.name ? this.setState({activeTab: r}) : null)}}>
                      <a  href="#">{r.name}</a>
                    </li>
                  })
                }
                {this.viewConfig.enabledViews.map((r, k) => {
                  var viewName = (r == "1h" ? "" : r);
                  var selected = (viewName == this.state.activeView);
                  var baseName = this.state.activeTab._id.split('_')[0];
                  var newTab = this.viewConfig.tabs[baseName + (viewName == "" ? viewName : "_" + viewName)];

                  return <li onClick={(event) => {event.preventDefault(); this.setState({activeView: viewName, activeTab: newTab})}} key={k} style={{}} className={selected ? "active " : ""}>
                    <a href="#">{"Pomiary " + r}</a>
                  </li>
                })}

                <li key={-3} className=""  style={{float: 'right', position: 'relative'}}>
                  <div style={{paddingTop: 6, width: 100}}>
                    <DatePicker
                        calendarContainer={document.body}
                        calendarPlacement="left"
                        dateFormat="YYYY/MM/DD HH:mm"
                        maxDate={new Date().toISOString()}
                        dayLabels={['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob']}
                        monthLabels={['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']}
                        showClearButton={false}
                        value={this.state.calendarISODate}
                        onChange={(date) => {this.initData(new Date(date))}}
                    />
                </div>
                </li>
                {/*
                <li key={-2} className="" title="Przeładuj" style={{marginLeft: '40', cursor: 'hand', float: 'right'}} onClick={this.onRefreshClicked.bind(this)}>
                  <a href="#" style={{float: 'right'}}>
                    <span style={{}} className="">
                      {
                        this.state.json.queryTime ? new Moment(new Date(this.state.json.queryTime * 1000)).format("YYYY-MM-DD HH:mm") : ""
                      }
                      <span style={{position: 'absolute', fontSize: "9px !important", top: 27, left: 56, float: 'right', color: 'black'}} className="">
                        {
                          this.lastFetch ? new Moment(this.lastFetch).format("YYYY-MM-DD HH:mm:ss") : ""
                        }
                      </span>
                    </span>
                  </a>
                </li>
               */}
              </ul>
            </div>
          </div>
        </nav>
        <div style={{marginTop: 50, clear: 'both'}}/>
        <div key={2} ref="chart" style={{width: chartWidth, float: 'left'}}>
          {charts && charts.length > 0 && charts.map((s, i) => {
            var sd = s[0];
            var title;
            var code = sd.name;
            var meas = dp.getStore('measurement_by_code').getRecordById(code);
            var compound_type = dp.getStore('chemical_compound').getRecordById(meas.compound_type);


            console.log('what is name: ', sd.name)

            //console.log('compound_type: ', compound_type, meas.compound_type)
            //var legendComponent = <LegendComponent title={mapUnitNameToTag(meas.agg_unit)} series={s}/>;

            title = s.title;

            var disableMouseEvent = false;
            var height = chartHeight - 30;

            //console.log('my title: ', titles, sd.name)
            return <div key={this.state.activeTab.name + "_" + i} className="panel panel-default" style={{padding: 0, margin: 0, textAlign: "center", width: chartWidth, float: 'left'}}>
              <div key={-1} style={{width: "100%",  textAlign: 'center'}} className="panel-heading">
                <span dangerouslySetInnerHTML={{
                    __html: title
                    .replace(/PM10/g, mapParTypeName('PM10'))
                    .replace(/PM1/g, mapParTypeName('PM1'))
                    .replace(/PM25/g, mapParTypeName('PM25'))
                    .replace(/PM2\.5/g, mapParTypeName('PM25'))
                  }} style={{fontStyle: 'italic'}}>
                </span>
              </div>
              <div key={0} style={{width: chartWidth, float: 'top', padding: 0, margin: 0, paddingBottom: 5}} className="panel-body">
                <LineChart onResize={this.reportSizeChange.bind(this)} containerHeight={height}
                  reactiveDescription={reactiveDescription} disableMouseEvent={disableMouseEvent}
                  LegendComponent={LegendComponent} legendProps={{title: mapUnitNameToTag(meas.agg_unit), series: s}}
                  //    legendComponent={legendComponent}
                  shared_extent={s.length > 1} series={s}
                  shared_extent_base={s[0].sharedExtentBase}
                  shared_extent_ceil={s[0].sharedExtentCeil}
                  />
              </div>
            </div>
          })}
        </div>

        <div style={{clear: 'both'}}></div>
        <div style={{ width: tableWidth, marginTop: 0, padding: 0, margin: 0}} className="panel panel-default">
          <div key={-1} style={{textAlign: 'center'}} className="panel-heading">
            <span style={{fontStyle: 'italic'}}>
              Tabela danych pomiarowych
            </span>
          </div>
          <div className="panel-body" style={{padding: 0, margin: 0}}>
          {this.generateTable(
          (this.viewConfig.blocks.tablething.hasOwnProperty(baseName) && this.viewConfig.blocks.tablething[baseName].headersDescription) || this.viewConfig.headersDescription,
          (this.viewConfig.blocks.tablething.hasOwnProperty(baseName) && this.viewConfig.blocks.tablething[baseName].codes) || this.viewConfig.blocks.tablething.codes,
          reactiveDescription,
          tableWidth,
          tableHeight
        )}
      </div>
    </div>

    </div>
  );
  }
}

export default KasCon;



// WEBPACK FOOTER //
// ./app/react/krynica/KrynicaCon.jsx